import React from 'react';
import { withContent } from '../../../hoc/withContext';
import { IContent } from '../../../types';
import { getSvgComponent } from '../../utils/svg';
import { IconWrapper, StarterPackFullSvg } from './StarterPackImagesStyle';
import PictureImage from '../../utils/Picture';
import { IBlock } from '../../../types/content';

export interface IStarterPackProps {
    currentlyDisplayedImage: number;
    context?: IContent;
    listBlocks: IBlock[];
}

const getImages = (blockList: IBlock[], currentlyDisplayedImage: number) => {
    const iconsList = blockList.map((block: IBlock, index: number) => block.icons.big && (
        <IconWrapper
            isActive={currentlyDisplayedImage === index}
            key={`starter-pack-image${index + 1}`}
        >
            {getSvgComponent(block.icons.big)}
        </IconWrapper>
    ));

    let ubisoftLinkImageOptions = null;

    if (window.anywhereAvailability) {
        if (window.anywhereAvailability.luna_available && window.anywhereAvailability.stadia_available) {
            ubisoftLinkImageOptions = {
                imageName: "stadiaLunaUbisoftLink",
                altText: "Ubisoft x Stadia + Luna"
            };
        } else if (window.anywhereAvailability.luna_available) {
            ubisoftLinkImageOptions = {
                imageName: "lunaUbisoftLink",
                altText: "Ubisoft x Luna"
            };
        } else if (window.anywhereAvailability.stadia_available) {
            ubisoftLinkImageOptions = {
                imageName: "stadiaUbisoftLink",
                altText: "Ubisoft x Stadia"
            };
        }
    }

    const ubisoftLinkImage = ubisoftLinkImageOptions && (
        <IconWrapper
            isActive={currentlyDisplayedImage === 0}
            key={`starter-pack-image0`}
        >
            <PictureImage
                images={[{
                    imageName: ubisoftLinkImageOptions.imageName,
                    minWidth: 0
                }]}
                extension="png"
                altText={ubisoftLinkImageOptions.altText}
                className={['']}
                containsWebp={false}
            />
        </IconWrapper>
    );

    return [
        ubisoftLinkImage,
        ...iconsList
    ].filter(el => el);
}

const StarterPackImages = ({
    currentlyDisplayedImage,
    listBlocks
}: IStarterPackProps) => {
    return (
        <StarterPackFullSvg>
            {getImages(listBlocks, currentlyDisplayedImage)}
        </StarterPackFullSvg>
    );
}

export default withContent(StarterPackImages);
